import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';

const MoneyBackGuarantee = () => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #E31837 0%, #C4122F 100%)',
      padding: window.innerWidth <= 768 ? '40px 20px' : '60px 40px',
      borderRadius: '16px',
      margin: '60px auto',
      maxWidth: '900px',
      boxShadow: '0 20px 60px rgba(227, 24, 55, 0.4)',
      border: '3px solid #FF1744',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)',
        opacity: 0.3
      }}></div>

      <div style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
        {/* Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          background: 'rgba(255, 255, 255, 0.2)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          border: '3px solid #FFFFFF'
        }}>
          <Shield style={{ 
            width: '40px', 
            height: '40px', 
            color: '#FFFFFF' 
          }} />
        </div>

        {/* Badge */}
        <div style={{
          display: 'inline-block',
          background: '#FFFFFF',
          color: '#E31837',
          padding: '8px 24px',
          borderRadius: '50px',
          fontSize: '14px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginBottom: '20px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
        }}>
          Garansi 100% Uang Kembali
        </div>

        {/* Title */}
        <h2 style={{
          fontSize: window.innerWidth <= 768 ? '28px' : '36px',
          fontWeight: 800,
          color: '#FFFFFF',
          marginBottom: '16px',
          lineHeight: 1.2,
          fontFamily: "'Montserrat', sans-serif"
        }}>
          Kepuasan Kamu Adalah Prioritas
        </h2>

        {/* Subtitle */}
        <p style={{
          fontSize: window.innerWidth <= 768 ? '16px' : '18px',
          color: 'rgba(255, 255, 255, 0.95)',
          marginBottom: '32px',
          lineHeight: 1.6,
          maxWidth: '700px',
          margin: '0 auto 32px'
        }}>
          Kami percaya dengan kualitas platform kami. Jika dalam <strong>30 hari pertama</strong> kamu merasa platform ini tidak sesuai dengan ekspektasi, kami menyediakan kebijakan pengembalian dana sesuai dengan syarat dan ketentuan yang berlaku.
        </p>

        {/* Features */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(3, 1fr)',
          gap: '20px',
          marginBottom: '32px'
        }}>
          {[
            { title: '30 Hari', desc: 'Garansi penuh' },
            { title: '100% Refund', desc: 'Tanpa ribet' },
            { title: 'Zero Risk', desc: 'Kamu aman' }
          ].map((item, index) => (
            <div key={index} style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
              padding: '24px',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.3)'
            }}>
              <CheckCircle style={{ 
                width: '32px', 
                height: '32px', 
                color: '#FFFFFF',
                marginBottom: '12px'
              }} />
              <div style={{
                fontSize: '20px',
                fontWeight: 700,
                color: '#FFFFFF',
                marginBottom: '4px'
              }}>
                {item.title}
              </div>
              <div style={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.9)'
              }}>
                {item.desc}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom text */}
        <p style={{
          fontSize: '13px',
          color: 'rgba(255, 255, 255, 0.8)',
          fontStyle: 'italic',
          lineHeight: 1.6
        }}>
          *Syarat & Ketentuan berlaku. Pengembalian dana hanya berlaku untuk biaya platform, tidak termasuk kerugian trading. Trading melibatkan risiko. Mohon baca syarat lengkap sebelum mendaftar.
        </p>
      </div>
    </div>
  );
};

export default MoneyBackGuarantee;
